import request from '@/utils/request'

const url = '/home/faster/'
const api = {
  onRodeChange (data) {
    return request({
      url: url + 'onRodeChange',
      method: 'post',
      data
    })
  },
  sureSkuList (data) {
    return request({
      url: url + 'sureSkuList',
      method: 'post',
      data
    })
  }
}
export default api



// WEBPACK FOOTER //
// ./src/api/faster.js